<template>
  <div class="editor-wrapper">
    <label :class="{ 'required-field': isRequired, 'validation-error': validationErrors.length }">
      {{ label }}
    </label>
    <vue-editor 
      v-model="editorContent" 
      :class="{ 'disabled-editor': disabled }"
      :editor-toolbar="customToolbar"
      :disabled="disabled"
      @blur="blur"
      :placeholder="placeholder"
    />
    <div
      v-if="validationErrors.length"
      class="error-message"
    >
      <span 
        v-for="(messageError, idx) in validationErrors" 
        :key="idx"
      >
        {{ messageError }}
      </span>
    </div>
  </div>
</template>

<script>
import { VueEditor } from 'vue2-editor'

export default {
  name: 'AppEditor',
  components: {
    VueEditor
  },
  props: {
    label: {
      type: String,
      default: () => ''
    },
    content: {
      type: String,
      default: () => ''
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    v: {
      type: Object,
      default: () => {}
    },
    isRequired: {
      type: Boolean,
      default: () => false
    },
    placeholder: {
      type: String,
      default: () => ''
    },
    options: {
      type: Array,
      default: () => (
        [
          [{ header: [false, 1, 2, 3, 4, 5, 6] }],
          ['bold', 'italic', 'underline', 'strike'], // toggled buttons
          [
            { align: '' },
            { align: 'center' },
            { align: 'right' },
            { align: 'justify' }
          ],
          ['blockquote', 'code-block'],
          [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
          [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
          [{ color: [] }, { background: [] }], // dropdown with defaults from theme
          ['link'],
          ['clean'] // remove formatting button
        ]
      )
    }
  },
  computed: {
    editorContent: {
      get() { return this.content },
      set(updatedContent) { this.$emit('update:content', updatedContent) }
    },
    validationErrors() {
      return this.$formErrors(this.v)
    },
    customToolbar() {
      return this.options
    }
  },
  methods: {
    blur() {
      if (this.v) this.v.$touch()
    },
  }
}
</script>

<style lang="stylus">
  .editor-wrapper
    label
      color: #8e8787
      margin-bottom: 30px
    .ql-editor
        min-height: 18rem;
        max-height: 18rem;
      .quillWrapper
        color: #8e8787
    .validation-error, .error-message
      color: var(--v-error-base)
    .error-message
      padding: 0.5rem 0;
      font-size: 12px;
  
  .disabled-editor
    .ql-snow.ql-toolbar 
      display: none;

    #quill-container
      border-top: 1px solid #ccc;
      background: rgba(0, 0, 0, .038);
      border-radius: 2px;
</style>
